var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrPolicyDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 84,
    viewBox: "0 0 66 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.25 51.375V40.4375C64.25 36.7079 62.7684 33.131 60.1312 30.4938C57.494 27.8566 53.9171 26.375 50.1875 26.375H43.9375C42.6943 26.375 41.502 25.8811 40.6229 25.0021C39.7439 24.123 39.25 22.9307 39.25 21.6875V15.4375C39.25 11.7079 37.7684 8.13104 35.1312 5.49381C32.494 2.85658 28.9171 1.375 25.1875 1.375H17.375M17.375 54.5H48.625M17.375 67H33M26.75 1.375H6.4375C3.85 1.375 1.75 3.475 1.75 6.0625V77.9375C1.75 80.525 3.85 82.625 6.4375 82.625H59.5625C62.15 82.625 64.25 80.525 64.25 77.9375V38.875C64.25 28.9294 60.2991 19.3911 53.2665 12.3585C46.2339 5.32588 36.6956 1.375 26.75 1.375Z",
    stroke: "#201E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrPolicyDevelopment);
export default __webpack_public_path__ + "static/media/HRPolicyDevelopment.c05f622da3593611f8d9c7ba37980165.svg";
export { ForwardRef as ReactComponent };